<script lang="ts" setup>
import { WalletConnectStatus } from '@/types'

const walletStore = useWalletStore()
const { success } = useNotifications()
const { $onError } = useNuxtApp()
const { t } = useLang()

const downloadMetamaskLink = ref<any>(null)

function connect() {
  walletStore
      .connectWalletConnect()
      .then(() => {
        success({ title: t('connect.successfullyConnected') })
      })
      .catch((e) => {
        console.error(e)
        walletStore.setWalletConnectStatus(WalletConnectStatus.disconnected)
        $onError(e)
      })
    }
</script>

<template>
  <LayoutWalletConnectWrapper @click="connect">
    <template #logo>
      <BaseIcon name="wallet/wallet-connect" class="w-8 h-8" />
    </template>

    <template #title>
      Wallet Connect
    </template>

    <template #description>
      <span data-cy="connect-wallet-popup-metamask-button">
        {{ $t('connect.connectUsingBrowser') }}
      </span>
    </template>

    <template v-if="!walletStore.metamaskInstalled" #icon>
      <NuxtLink
        ref="downloadMetamaskLink"
        to="https://metamask.io/download"
        target="_blank"
        rel="noreferrer"
      >
        <BaseIcon name="download" class="h-5 w-5 hover:text-blue-500" />
      </NuxtLink>
    </template>
  </LayoutWalletConnectWrapper>
</template>
